import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIleggelseKopi as getIleggelseKopiAction } from "../../../../actions/ileggelserActions";
import LoadButton from "../../LoadButton";

export default function KopiContainer() {
  const ileggelse = useSelector((state) => state.ileggelse);
  const dispatch = useDispatch();

  const [showKopiAvIleggelseSpinner, setShowKopiAvIleggelseSpinner] =
    useState(false);

  const onClickHandler = () => {
    setShowKopiAvIleggelseSpinner(true);
    dispatch(getIleggelseKopiAction(ileggelse.id, ileggelse.ileggelsesnummer))
      .then(() => setShowKopiAvIleggelseSpinner(false))
      .catch(() => setShowKopiAvIleggelseSpinner(false));
  };

  return (
    <LoadButton
      isLoading={showKopiAvIleggelseSpinner}
      buttonProps={{
        className: "btn btn-bym-standard",
        style: { marginRight: 20 },
        onClick: onClickHandler,
        disabled: showKopiAvIleggelseSpinner,
      }}
      spinnerProps={{ pColor: "#ffffff", sColor: "#4d4d4d" }}
    >
      Kopi av ileggelse
    </LoadButton>
  );
}
